export enum LoginEnum {
  BAD_CREDENTIALS = "UAA_AUTH_UNAU_ERR_2",
  ACCOUNT_NOT_FOUND = "UAA_RES_NOT_FND_ERR_4",
  ACCOUNT_NOT_ACTIVATED="UAA_AUTH_FORB_ERR_4",
  ACCOUNT_BLOCKED="UAA_AUTH_UNAU_ERR_5"
}
